export default __webpack_public_path__ + "static/media/MasaiXCourseImage2.2c2d50a8.svg";